import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { LogIn, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useAuth } from '../contexts/AuthContext';

const AdminLogin = () => {
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');

  return (
    <div className="min-h-screen bg-[#1F1A17] flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-[#2A2420] border-[#C5A880]/30">
        <CardContent className="p-8">
          <div className="text-center mb-8">
            <div className="text-3xl font-bold mb-2">
              <span className="text-[#EADBC8]">Mayden</span>
              <span className="text-[#C5A880] ml-1">Films</span>
            </div>
            <h1 className="text-2xl font-bold text-[#EADBC8] mb-2">Admin Panel</h1>
            <p className="text-gray-400 text-sm">Sign in to manage your website</p>
          </div>

          {error === 'not_admin' && (
            <div className="mb-6 p-4 bg-red-500/10 border border-red-500/30 rounded-lg flex items-start gap-3">
              <AlertCircle className="text-red-500 flex-shrink-0 mt-0.5" size={20} />
              <div>
                <p className="text-red-400 font-semibold text-sm">Access Denied</p>
                <p className="text-red-300/80 text-xs mt-1">
                  This Google account is not authorized for admin access.
                </p>
              </div>
            </div>
          )}

          {error === 'auth_failed' && (
            <div className="mb-6 p-4 bg-red-500/10 border border-red-500/30 rounded-lg flex items-start gap-3">
              <AlertCircle className="text-red-500 flex-shrink-0 mt-0.5" size={20} />
              <div>
                <p className="text-red-400 font-semibold text-sm">Sign in failed</p>
                <p className="text-red-300/80 text-xs mt-1">Please try again.</p>
              </div>
            </div>
          )}

          <Button
            onClick={login}
            data-testid="admin-google-login-btn"
            className="w-full bg-[#C5A880] hover:bg-[#D4BC95] text-[#1F1A17] font-semibold py-6 text-base transition-all duration-300"
          >
            <LogIn className="mr-2" size={20} />
            Sign in with Google
          </Button>

          <p className="text-gray-500 text-xs text-center mt-6">
            Only authorized admin emails can access this panel.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
